/* istanbul ignore file */
const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  legend: {
    show: true,
    position: 'bottom',
    fontFamily: 'Roboto Condensed',
    fontSize: 17,
    formatter: (string) => string.charAt(0).toUpperCase() + string.slice(1),
  },
  plotOptions: {
    pie: {
      donut: {
        size: '87',
        labels: {
          show: true,
          value: {
            fontFamily: 'Roboto',
            fontSize: 30,
            fontWeight: 'bold',
          },
          total: {
            show: true,
            color: '#898989',
            fontFamily: 'Roboto',
            fontWeight: 300,
            fontSize: 16,
          },
        },
      },
    },
    radialBar: {
      endingShape: 'rounded',
      hollow: {
        size: '78',
      },
      dataLabels: {
        value: {
          fontFamily: 'Roboto',
          fontSize: 30,
          fontWeight: 'bold',
        },
        total: {
          show: true,
          color: '#898989',
          fontFamily: 'Roboto',
          fontWeight: 300,
          fontSize: 16,
          formatter: (w) => {
            let total = 0;
            w.globals.series.forEach((el) => {
              total += el;
            });
            return total;
          },
        },
      },
    },
    bar: {
      horizontal: false,
      columnWidth: '23%',
      endingShape: 'rounded',
      borderRadius: 5,
    },
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    x: {
      show: false,
    },
    y: {
      title: {
        formatter: (labels) => labels.charAt(0).toUpperCase() + labels.slice(1),
      },
    },
  },
};
export default chartOptions;
